import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { useFormContext } from 'react-hook-form';
import { Icon } from '../icon';
import { Tooltip } from '../tooltip';
import { Field } from 'src/shared/components/form/field';
import { Preview } from './preview';
import { UploadPopover } from './uploadPopover';
export function UploadCover({ value, label, tooltip, fieldName, entityType, onUploadEnd, priorityImage, hideActionButton = false, hideGalleryInfo = false }) {
    const { setValue } = useFormContext();
    const [selectedFile, setSelectedFile] = useState(value);
    useEffect(function effectFillCover() {
        setSelectedFile(value);
    }, [value]);
    function applyFile() {
        setValue(fieldName, selectedFile, { shouldDirty: true });
    }
    return (_jsxs(Field, { className: "mb-6", children: [_jsxs("div", { className: "mb-2 flex items-center", children: [_jsx(Field.Label, { className: "m-0", children: label }), Boolean(tooltip) && (_jsx(Tooltip, { text: tooltip, className: "ml-2", children: _jsx(Icon, { icon: faInfoCircle }) }))] }), _jsx(Preview, { image: priorityImage || (selectedFile?.url ?? '') }), !hideActionButton && (_jsx(UploadPopover, { appliedFile: value, onApply: applyFile, entityType: entityType, onUploadEnd: onUploadEnd, selectedFile: selectedFile, onSelectFile: setSelectedFile, hideGalleryInfo: hideGalleryInfo }))] }));
}
